/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;flex-direction:column}h1[_ngcontent-%COMP%]{font-family:\"PT Sans\",sans-serif;font-size:28px;font-weight:400;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal}.buttons[_ngcontent-%COMP%]{display:flex;justify-content:center}button[_ngcontent-%COMP%]{margin:5px}"];
export { styles as styles };
